import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "../../../redux/user/action";
import { CardBody } from "reactstrap";
import CopyIcon from "../../../Components/assets/images/copy-img.svg";

const UserAddress = ({ id }) => {
  const selectedUsers = useSelector(({ user: { userbyid } }) => userbyid);

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
    }
  }, [id]);

  const handleCopyAPIKey = (code) => {
    navigator.clipboard
      .writeText(code)
      .then(() => alert("Token is copied"))
      .catch((err) => console.error("Error copying text:", err));
  };

  return (
    <div className="">
      <CardBody className="table-sec px-0">
        <table className="table">
          <thead>
            <tr>
              <th>Environment </th>
              <th>Api Token</th>
            </tr>
          </thead>
          <tbody>
            {selectedUsers.api_key && (
              <tr>
                <td>Production</td>
                <td>
                  {selectedUsers.api_key} {"     "}{" "}
                  <img
                    src={CopyIcon}
                    alt=""
                    onClick={() =>
                      handleCopyAPIKey(selectedUsers.staging_api_key)
                    }
                    style={{ cursor: "pointer" }}
                  />
                </td>
              </tr>
            )}
            {selectedUsers.staging_api_key && (
              <tr>
                <td>Sandbox</td>
                <td>
                  {selectedUsers.staging_api_key}
                  {"    "}

                  <img
                    src={CopyIcon}
                    alt=""
                    onClick={() =>
                      handleCopyAPIKey(selectedUsers.staging_api_key)
                    }
                    style={{ cursor: "pointer" }}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardBody>
    </div>
  );
};

export default UserAddress;
